'use strict';
angular.module('TurneroApp').component('coCalendario', {
    bindings: {
        usuario: '<',
        mostrarPuestos: '<'
    },
    controller: ['$window', 'turnosService', '$state', '$rootScope', '$scope', 'calendarioService', 'utilsService', '$mdDialog', 'TurneroAppConstant',
        function ($window, turnosService, $state, $rootScope, $scope, calendarioService, utilsService, $mdDialog, TurneroAppConstant) {
            var ctrl = this;
            ctrl.guardarTurno_data = null;
            ctrl.guardarTurno_anterior = null;
            ctrl.Id_Agenda = '';
            ctrl.Id_Tramite_Relevado = '';
            ctrl.idRefGuiaTramitesMunicipal = null;
            ctrl.semanaAnterirorPulsada = false;
            ctrl.DiaLaboral = false;
            ctrl.ReadOnly = false;
            ctrl.UrlGuiaTramitesMunicipalHome = TurneroAppConstant.url.Guia_Tramites_Municipal_Home;
            ctrl.UrlGuiaTramitesMunicipalConId = TurneroAppConstant.url.Guia_Tramites_Municipal_Con_Id;
            ctrl.UrlGuiaTramites = null;
            /* ctrl.semanaActual va a tener el lunes de la semana actual. en el caso HOY sea Domingo, le resto 6 dias para obtener el lunes de la semana de HOY
         en caso de que hoy sea un dia de la semana comun, le resto (el numero de dia  - 1 ) que me retorna el lunes de la semana.
         */
            ctrl.semanaActual = moment(moment(moment().add((moment().toDate().getDay() > 0 ? -(moment().toDate().getDay() - 1) : (-6)), 'days'))).toDate();
            //$state padre
            ctrl.layoutState = $state.$current.name.split('.')[0];
            ctrl.semana = {};

            ctrl.limpiarMemoria = function () {
                $rootScope.$broadcast('esHome', false);
                $rootScope.$broadcast('esCalendario', true);
                $rootScope.$broadcast('esTasaRetributiva', false);
            }

            ctrl.$onInit = function () {
                ctrl.limpiarMemoria();
            };

            ctrl.CambiarSection = function () {
                document.getElementById("Section-Turnos").style.width = !ctrl.DiaLaboral ? "100%" : "133%";
                document.getElementById("Section-Turnos").style.borderRight = !ctrl.DiaLaboral ? "1px solid #DDD" : "none";
                document.getElementById("Section-Turnos").style.borderBottom = !ctrl.DiaLaboral ? "1px solid #DDD" : "none";
            }

            ctrl.btnAnterior_ocultar = function () {
                if (ctrl.semana.Anterior) {
                    if (ctrl.semana.Anterior < moment(ctrl.semanaActual.toDateString()).toDate()) {
                        return true;
                    }
                    if (ctrl.semana.Anterior < moment(ctrl.semana.primeraFecha.toDateString()).toDate()) {
                        return true;
                    }

                    return false;
                }
                return true;

            }

            ctrl.guardarTurno = function (hora, horahasta, fecha) {

                let tieneFechaSeleccionada = ctrl.guardarTurno_anterior != null;
                let fechaSeleccionadaNuevamente = false;

                if (ctrl.guardarTurno_anterior && ctrl.guardarTurno_anterior.dia === fecha && ctrl.guardarTurno_anterior.hora === hora && ctrl.guardarTurno_anterior.horaHasta === horahasta) {
                    ctrl.guardarTurno_data = null;
                    fechaSeleccionadaNuevamente = true;
                }
                else
                {
                    ctrl.guardarTurno_data = {
                        dia: fecha,
                        hora: hora,
                        horaHasta: horahasta
                    };
                }

                angular.forEach(ctrl.CalendarioArmado, function (value, key) {

                    if (tieneFechaSeleccionada) {

                        if (value.lunes != null && value.lunes.Fecha == moment(ctrl.guardarTurno_anterior.dia).format('DD/MM/YYYY').toString() && value.lunes.Hora_Desde == ctrl.guardarTurno_anterior.hora && value.lunes.Hora_Hasta == ctrl.guardarTurno_anterior.horaHasta) {
                            value.lunes.esSeleccionado = false;
                        }

                        if (value.martes != null && value.martes.Fecha == moment(ctrl.guardarTurno_anterior.dia).format('DD/MM/YYYY').toString() && value.martes.Hora_Desde == ctrl.guardarTurno_anterior.hora && value.martes.Hora_Hasta == ctrl.guardarTurno_anterior.horaHasta) {
                            value.martes.esSeleccionado = false
                        }

                        if (value.miercoles != null && value.miercoles.Fecha == moment(ctrl.guardarTurno_anterior.dia).format('DD/MM/YYYY').toString() && value.miercoles.Hora_Desde == ctrl.guardarTurno_anterior.hora && value.miercoles.Hora_Hasta == ctrl.guardarTurno_anterior.horaHasta) {
                            value.miercoles.esSeleccionado = false;
                        }

                        if (value.jueves != null && value.jueves.Fecha == moment(ctrl.guardarTurno_anterior.dia).format('DD/MM/YYYY').toString() && value.jueves.Hora_Desde == ctrl.guardarTurno_anterior.hora && value.jueves.Hora_Hasta == ctrl.guardarTurno_anterior.horaHasta) {
                            value.jueves.esSeleccionado = false;
                        }

                        if (value.viernes != null && value.viernes.Fecha == moment(ctrl.guardarTurno_anterior.dia).format('DD/MM/YYYY').toString() && value.viernes.Hora_Desde == ctrl.guardarTurno_anterior.hora && value.viernes.Hora_Hasta == ctrl.guardarTurno_anterior.horaHasta) {
                            value.viernes.esSeleccionado = false;
                        }

                        if (value.sabado != null && value.sabado.Fecha == moment(ctrl.guardarTurno_anterior.dia).format('DD/MM/YYYY').toString() && value.sabado.Hora_Desde == ctrl.guardarTurno_anterior.hora && value.sabado.Hora_Hasta == ctrl.guardarTurno_anterior.horaHasta) {
                            value.sabado.esSeleccionado = false;
                        }

                        if (value.domingo != null && value.domingo.Fecha == moment(ctrl.guardarTurno_anterior.dia).format('DD/MM/YYYY').toString() && value.domingo.Hora_Desde == ctrl.guardarTurno_anterior.hora && value.domingo.Hora_Hasta == ctrl.guardarTurno_anterior.horaHasta) {
                            value.domingo.esSeleccionado = false;
                        }
                    }

                    if (fechaSeleccionadaNuevamente == false && value.lunes != null && value.lunes.Fecha == moment(fecha).format('DD/MM/YYYY').toString() && value.lunes.Hora_Desde == hora && value.lunes.Hora_Hasta == horahasta) {
                        value.lunes.esSeleccionado = true;
                    }

                    if (fechaSeleccionadaNuevamente == false && value.martes != null && value.martes.Fecha == moment(fecha).format('DD/MM/YYYY').toString() && value.martes.Hora_Desde == hora && value.martes.Hora_Hasta == horahasta) {
                        value.martes.esSeleccionado = true;
                    }

                    if (fechaSeleccionadaNuevamente == false && value.miercoles != null && value.miercoles.Fecha == moment(fecha).format('DD/MM/YYYY').toString() && value.miercoles.Hora_Desde == hora && value.miercoles.Hora_Hasta == horahasta) {
                        value.miercoles.esSeleccionado = true;
                    }

                    if (fechaSeleccionadaNuevamente == false && value.jueves != null && value.jueves.Fecha == moment(fecha).format('DD/MM/YYYY').toString() && value.jueves.Hora_Desde == hora && value.jueves.Hora_Hasta == horahasta) {
                        value.jueves.esSeleccionado = true;
                    }

                    if (fechaSeleccionadaNuevamente == false && value.viernes != null && value.viernes.Fecha == moment(fecha).format('DD/MM/YYYY').toString() && value.viernes.Hora_Desde == hora && value.viernes.Hora_Hasta == horahasta) {
                        value.viernes.esSeleccionado = true;
                    }

                    if (fechaSeleccionadaNuevamente == false && value.sabado != null && value.sabado.Fecha == moment(fecha).format('DD/MM/YYYY').toString() && value.sabado.Hora_Desde == hora && value.sabado.Hora_Hasta == horahasta) {
                        value.sabado.esSeleccionado = true;
                    }

                    if (fechaSeleccionadaNuevamente == false && value.domingo != null && value.domingo.Fecha == moment(fecha).format('DD/MM/YYYY').toString() && value.domingo.Hora_Desde == hora && value.domingo.Hora_Hasta == horahasta) {
                        value.domingo.esSeleccionado = true;
                    }
                });

                if (!fechaSeleccionadaNuevamente)
                {
                    ctrl.guardarTurno_anterior = Object.assign({}, ctrl.guardarTurno_data);
                }
            }

            ctrl.siguiente = function () {
                if (ctrl.guardarTurno_data != null) {
                    $state.go(ctrl.layoutState + '.confirmacion');
                    $rootScope.$broadcast('seleccionarTurno', ctrl.guardarTurno_data);
                }
            }
            
            $scope.$on('cambioAgenda', function (event, Id_agenda, tramite) {
                if (Id_agenda && tramite) {
                    ctrl.Id_Agenda = Id_agenda;
                    ctrl.Id_Tramite_Relevado = tramite.Id_Tramite_Relevado
                    ctrl.idRefGuiaTramitesMunicipal = tramite.Id_Ref_Guia_Tramites_Municipal;
                    ctrl.cambiarDia(ctrl.fechaSeleccionada != new moment().toDate() && ctrl.fechaSeleccionada ? ctrl.fechaSeleccionada : new moment().toDate());
                }
            });

            ctrl.cambiarDia = function (fecha) {
                fecha = moment(fecha, "DD-MM-YYYY")._d;
                if (fecha.getDay() == 0) {
                    fecha = moment(moment(fecha).add(-7, 'days')).toDate();
                    //fecha.setDate(fecha.getDate() - 7)
                };

                //Obtengo la fecha del domingo del date picker

                fecha = moment(moment(fecha).add(-(fecha.getDay()), 'days')).toDate();
                //Obtengo la fecha del Lunes de la semana
                var fechaLunes = new Date();
                fechaLunes = moment(moment(fecha).add(1, 'days')).toDate();

                ctrl.guardarTurno_data = null;
                ctrl.obtenerDiasxSemana(fechaLunes);
            }
            ctrl.botonAnterior = function (fechaLunes, cargarNuevamente) {
                ctrl.semanaAnterirorPulsada = true;
                ctrl.obtenerDiasxSemana(fechaLunes, cargarNuevamente);
            };

            ctrl.obtenerDiasxSemana = function (fechaLunes) {
                ctrl.semana.Dias = [];
                ctrl.semana.Siguiente = moment(moment(fechaLunes).add(7, 'days')).format('DD/MM/YYYY').toDate();

                ctrl.semana.Anterior = moment(moment(fechaLunes).add(-7, 'days')).format('DD/MM/YYYY').toDate();

                for (var i = 0; i < 7; i++) {
                    var fecha = moment(moment(fechaLunes).add(i, 'days')).format('DD/MM/YYYY').toDate();
                    ctrl.semana.Dias[i] = fecha;
                }

                ctrl.getCalendario(ctrl.Id_Agenda, ctrl.semana.Dias[0]);


            }

            ctrl.mostrarFecha = function (fecha_calendario, fecha) {
                var momentDate = moment(fecha_calendario, 'DD/MM/YYYY')._d;
                if (momentDate.getDate() == fecha.getDate() && momentDate.getMonth() == fecha.getMonth() && momentDate.getYear() == fecha.getYear()) {
                    return true;
                }
                return false;
            };

            ctrl.ParseValues = function (value) {
                if (value) {
                    if (value.Id_Bloqueo_Calendario != 0) {
                        return 'B'; //Bloqueado
                    } else if (parseInt(value.Libre) > 0) {
                        return 'L';//Disponible
                    } else {
                        return 'O';//Ocupado
                    }
                } else return false;

            }

            ctrl.validarFechaEnSemana = function (fecha) {
                //Verifico si la fecha que devuelve el calendario se encuentra dentro de la semana cargada  : True, sino : False
                var resultado = false;
                for (var i = 0; i < ctrl.semana.Dias.length; i++) {
                    if (ctrl.mostrarFecha(moment(fecha).toDate(), ctrl.semana.Dias[i])) {
                        resultado = true;
                        break;
                    }
                }
                return resultado;

            }

            ctrl.getCalendario = function (Id_Agenda, fecha) {
                utilsService.swalNotification('Un momento...', 'Consultando disponibilidad...', 'info');
                ctrl.CalendarioArmado = [];
                ctrl.UrlGuiaTramites = ctrl.idRefGuiaTramitesMunicipal
                    ? ctrl.UrlGuiaTramitesMunicipalConId + ctrl.idRefGuiaTramitesMunicipal
                    : ctrl.UrlGuiaTramitesMunicipalHome

                calendarioService.Get_Calendario_Online({ 'id_agenda': Id_Agenda, 'fecha': fecha, 'Id_Tramite_Relevado': ctrl.Id_Tramite_Relevado}, function (resultado) {
                    try {
                        ctrl.semana.ultimaFecha = moment(moment(resultado.Data.Fecha_Ultimo_Turno)).toDate();
                        ctrl.semana.primeraFecha = moment(moment(resultado.Data.Fecha_Primer_Turno)).toDate();
                        ctrl.semana.ultimaSemana = moment(moment(ctrl.semana.ultimaFecha)).toDate();
                        ctrl.semana.Lunes_Semana_Calendario = moment(moment(resultado.Data.Fecha_Disponible)).toDate();
                        if (ctrl.validarFechaEnSemana(resultado.Data.Fecha_Disponible)) {
                            ctrl.Calendario = resultado.Data;
                            if (ctrl.Calendario.Filas.length) {
                                ctrl.armadoCalendario(ctrl.Calendario.Filas);
                            } else {
                                ctrl.regresar();
                            }
                            ctrl.semanaAnterirorPulsada = false;
                        } else {
                            if (ctrl.semanaAnterirorPulsada) {
                                ctrl.cambiarDia(moment(moment(fecha).add(-7, 'days')).toDate(), true);
                            }
                            else {
                                ctrl.cambiarDia(moment(resultado.Data.Fecha_Disponible), true);
                            }
                        }
                        //Maquetado en duro para probar el modal de tasas seleccionar(cuenta verificada nivel 2, centro de capacitacion)
                        //if (ctrl.Id_Tramite_Relevado == 1648 && Id_Agenda == 7424 && $rootScope.Id_Centro_Atencion == 322) {
                        //    $mdDialog.show({
                        //        template: require('../../turnos/turnosOnline/modalGenerarTasa.html'),
                        //        parent: angular.element(document.body),
                        //        clickOutsideToClose: false,
                        //        fullscreen: false,
                        //        controllerAs: '$ctrl',
                        //        controller: function () {
                        //            return ctrl;
                        //        }
                        //    });
                        //}
                    } catch (e) {
                        utilsService.errores(e, null, null, ctrl.UrlGuiaTramites);
                    }
                }, function (error) {
                    utilsService.errores(error, ctrl.regresar, null,  ctrl.UrlGuiaTramites);
                });
            }

            ctrl.cerrarModal = function (readonly) {
                ctrl.ReadOnly = readonly;
                $mdDialog.destroy();
            };

            ctrl.GenerarTasas = function (){
                $mdDialog.destroy();
                $rootScope.$broadcast('esTasaRetributiva', true);
                $state.go('ciudadano.tasas');
            }

            ctrl.regresar = function () {
                $state.go('ciudadano.tramites')
            }

            ctrl.armadoCalendario = function (Filas) {
                utilsService.swalNotification('Un momento...', 'Armando calendario...', 'info');
                ctrl.CalendarioArmado = [];
                for (var i = 0; i < Filas.length; i++) {
                    var arrayElement = {
                        hora: null,
                        lunes: null,
                        martes: null,
                        miercoles: null,
                        jueves: null,
                        viernes: null,
                        sabado: null,
                        domingo: null
                    };
                    arrayElement.hora = Filas[i].Hora_Desde;
                    var arrayElement_Hora_Hasta = arrayElement;
                    for (var j = 0; j < 7; j++) {
                        if (Filas[i] && arrayElement.hora == Filas[i].Hora_Desde) {
                            switch (j) {
                                case 0:
                                    if (ctrl.mostrarFecha(Filas[i].Fecha, ctrl.semana.Dias[j])) {                                        
                                        arrayElement.lunes = Filas[i];

                                        if (ctrl.guardarTurno_data != null)
                                            arrayElement.lunes.esSeleccionado = (moment(ctrl.guardarTurno_data.dia).format('DD/MM/YYYY').toString() == arrayElement.lunes.Fecha && arrayElement.lunes.Hora_Desde == ctrl.guardarTurno_data.hora && arrayElement.lunes.Hora_Hasta == ctrl.guardarTurno_data.horaHasta);
                                        else
                                            arrayElement.lunes.esSeleccionado = false;

                                        arrayElement.lunes.Cant_Puestos = Filas[i].Libre + Filas[i].Ocupado;
                                        arrayElement.lunes.Cant_Puestos_Array = ctrl.generarArray(arrayElement.lunes.Cant_Puestos, Filas[i].Ocupado);
                                        i++;
                                    }
                                    break;
                                case 1:
                                    if (ctrl.mostrarFecha(Filas[i].Fecha, ctrl.semana.Dias[j])) {
                                        arrayElement.martes = Filas[i];
                                        
                                        if (ctrl.guardarTurno_data != null) 
                                            arrayElement.martes.esSeleccionado = (moment(ctrl.guardarTurno_data.dia).format('DD/MM/YYYY').toString() == arrayElement.martes.Fecha && arrayElement.martes.Hora_Desde == ctrl.guardarTurno_data.hora && arrayElement.martes.Hora_Hasta == ctrl.guardarTurno_data.horaHasta);                                        
                                        else
                                            arrayElement.martes.esSeleccionado = false;

                                        arrayElement.martes.Cant_Puestos = Filas[i].Libre + Filas[i].Ocupado;
                                        arrayElement.martes.Cant_Puestos_Array = ctrl.generarArray(arrayElement.martes.Cant_Puestos, Filas[i].Ocupado);
                                        i++;
                                    }
                                    break;
                                case 2:
                                    if (ctrl.mostrarFecha(Filas[i].Fecha, ctrl.semana.Dias[j])) {
                                        arrayElement.miercoles = Filas[i];

                                        if (ctrl.guardarTurno_data != null)
                                            arrayElement.miercoles.esSeleccionado = (moment(ctrl.guardarTurno_data.dia).format('DD/MM/YYYY').toString() == arrayElement.miercoles.Fecha && arrayElement.miercoles.Hora_Desde == ctrl.guardarTurno_data.hora && arrayElement.miercoles.Hora_Hasta == ctrl.guardarTurno_data.horaHasta);
                                        else
                                            arrayElement.miercoles.esSeleccionado = false;

                                        arrayElement.miercoles.Cant_Puestos = Filas[i].Libre + Filas[i].Ocupado;
                                        arrayElement.miercoles.Cant_Puestos_Array = ctrl.generarArray(arrayElement.miercoles.Cant_Puestos, Filas[i].Ocupado);
                                        i++;
                                    }
                                    break;
                                case 3:
                                    if (ctrl.mostrarFecha(Filas[i].Fecha, ctrl.semana.Dias[j])) {
                                        arrayElement.jueves = Filas[i];

                                        if (ctrl.guardarTurno_data != null)
                                            arrayElement.jueves.esSeleccionado = (moment(ctrl.guardarTurno_data.dia).format('DD/MM/YYYY').toString() == arrayElement.jueves.Fecha && arrayElement.jueves.Hora_Desde == ctrl.guardarTurno_data.hora && arrayElement.jueves.Hora_Hasta == ctrl.guardarTurno_data.horaHasta);
                                        else
                                            arrayElement.jueves.esSeleccionado = false;

                                        arrayElement.jueves.Cant_Puestos = Filas[i].Libre + Filas[i].Ocupado;
                                        arrayElement.jueves.Cant_Puestos_Array = ctrl.generarArray(arrayElement.jueves.Cant_Puestos, Filas[i].Ocupado);
                                        i++;
                                    }
                                    break;
                                case 4:
                                    if (ctrl.mostrarFecha(Filas[i].Fecha, ctrl.semana.Dias[j])) {
                                        arrayElement.viernes = Filas[i];

                                        if (ctrl.guardarTurno_data != null)
                                            arrayElement.viernes.esSeleccionado = (moment(ctrl.guardarTurno_data.dia).format('DD/MM/YYYY').toString() == arrayElement.viernes.Fecha && arrayElement.viernes.Hora_Desde == ctrl.guardarTurno_data.hora && arrayElement.viernes.Hora_Hasta == ctrl.guardarTurno_data.horaHasta);
                                        else
                                            arrayElement.viernes.esSeleccionado = false;

                                        arrayElement.viernes.Cant_Puestos = Filas[i].Libre + Filas[i].Ocupado;
                                        arrayElement.viernes.Cant_Puestos_Array = ctrl.generarArray(arrayElement.viernes.Cant_Puestos, Filas[i].Ocupado);
                                        i++;
                                    }
                                    break;
                                case 5:
                                    if (ctrl.mostrarFecha(Filas[i].Fecha, ctrl.semana.Dias[j])) {
                                        arrayElement.sabado = Filas[i];

                                        if (ctrl.guardarTurno_data != null)
                                            arrayElement.sabado.esSeleccionado = (moment(ctrl.guardarTurno_data.dia).format('DD/MM/YYYY').toString() == arrayElement.sabado.Fecha && arrayElement.sabado.Hora_Desde == ctrl.guardarTurno_data.hora && arrayElement.sabado.Hora_Hasta == ctrl.guardarTurno_data.horaHasta);
                                        else
                                            arrayElement.sabado.esSeleccionado = false;
                                        
                                        arrayElement.sabado.Cant_Puestos = Filas[i].Libre + Filas[i].Ocupado;
                                        arrayElement.sabado.Cant_Puestos_Array = ctrl.generarArray(arrayElement.sabado.Cant_Puestos, Filas[i].Ocupado);
                                        i++;
                                    }
                                    break;
                                case 6:
                                    if (ctrl.mostrarFecha(Filas[i].Fecha, ctrl.semana.Dias[j])) {
                                        arrayElement.domingo = Filas[i];

                                        if (ctrl.guardarTurno_data != null)
                                            arrayElement.domingo.esSeleccionado = (moment(ctrl.guardarTurno_data.dia).format('DD/MM/YYYY').toString() == arrayElement.domingo.Fecha && arrayElement.domingo.Hora_Desde == ctrl.guardarTurno_data.hora && arrayElement.domingo.Hora_Hasta == ctrl.guardarTurno_data.horaHasta);
                                        else
                                            arrayElement.domingo.esSeleccionado = false;
                                        
                                        arrayElement.domingo.Cant_Puestos = Filas[i].Libre + Filas[i].Ocupado;
                                        arrayElement.domingo.Cant_Puestos_Array = ctrl.generarArray(arrayElement.domingo.Cant_Puestos, Filas[i].Ocupado);
                                        i++;
                                    }
                                    break;
                            }

                        }
                    }
                    ctrl.CalendarioArmado.push(arrayElement);
                    i = i - 1;
                }
                swal.close();
            }
            ctrl.generarArray = function (cantidad, cantOcupados) {
                var arrayResult = [];
                for (var i = 1; i <= cantidad; i++) {
                    var item = {
                        id: i,
                        ocupado: i <= cantOcupados
                    }
                    arrayResult.push(item);
                }
                return arrayResult;

            }

            ctrl.copiarURL = function () {
                if ($rootScope.Id_Centro_Atencion && ctrl.Id_Tramite_Relevado && ctrl.Id_Agenda) {
                    copiarAlPortapapeles($rootScope.urlHostServer + 'turnos?idCentroAtencion=' + $rootScope.Id_Centro_Atencion + '&tramitePortal=' + ctrl.Id_Tramite_Relevado + '&idAgenda=' + ctrl.Id_Agenda);
                    sweetAlert('¡URL Copiada!', 'Recuerde Iniciar Sesión en CiDi para poder ingresar a la URL.', 'success').catch(swal.noop);
                }
            }

            function copiarAlPortapapeles(elemento) {
                var $temp = $("<input>")
                $("body").append($temp);
                $temp.val(elemento).select();
                document.execCommand("copy");
                $temp.remove();
            }
        }],
    template: require('./turnoOnlineCalendario.html')
});



// WEBPACK FOOTER //
// ./app/components/turnos/turnosOnline/turnoOnlineCalendarioComponent.js